// -----------------------------------------------------------------------------
// Scripts for product gallery
// -----------------------------------------------------------------------------

$(function () {
  $(`#productGallery`).slick({
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    fade: true,
    arrows: true,
    dots: false,
  });
});